export default {
  default: () => import("/builds/vapebay/commerce-frontend/layouts/default.vue").then(m => m.default || m)
}